import React from 'react';

import {ListMessage} from 'app/components/general/ListMessage';
import {gt, ngt} from 'app/utils/i18n';

import {QuizSerializedType} from 'sweet-types';

type Props = {
  quiz: QuizSerializedType;
};

export const HiddenViewContent = ({quiz}: Props) => (
  <>
    {quiz.num_questions != undefined ? (
      <ListMessage>
        {ngt(
          'This quiz has %s question.',
          'This quiz has %s questions.',
          quiz.num_questions
        )}{' '}
        {gt('Take the quiz')}
      </ListMessage>
    ) : (
      <ListMessage>{gt('Loading.')}</ListMessage>
    )}
  </>
);
